import { Component, computed, inject, input } from '@angular/core';
import { SharedModule } from '@app/shared/shared.module';
import { ProgressBarComponent } from '@app/shared/components/progress-bar/progress-bar.component';
import { DisplayComponent } from '@app/shared/components/display/display.component';
import { Casino } from '../../progress-line.model';
import { ProgressLineFacade } from '@app/progress-line/progress-line.facade';

@Component({
  selector: 'slotcom-end-game-reward',
  templateUrl: './end-game-reward.component.html',
  styleUrls: ['./end-game-reward.component.scss'],
  standalone: true,
  imports: [SharedModule, ProgressBarComponent, DisplayComponent],
})
export class EndGameRewardComponent {
  private readonly progressLineFacade = inject(ProgressLineFacade);

  readonly casino = input.required<Casino>();
  readonly endGameMilestone = computed(() => this.casino().endGameMilestone);
  readonly prizeUI = computed(() => this.progressLineFacade.getPrizeUI(this.endGameMilestone().prizes[0]));
}
